import { Link, useRouterState } from "@tanstack/react-router";
import { clsx } from "clsx";
import { useSidebarStore } from "@/hooks/useSidebar";
import type { NavLink } from "@/types/navigation";

export function isPathActive(
  pathname: string,
  href: string,
  exact?: boolean,
): boolean {
  if (exact) {
    return pathname === href;
  }
  return pathname === href || pathname.startsWith(`${href}/`);
}

interface SidebarNavItemProps {
  item: NavLink;
  nested?: boolean;
}

export function SidebarNavItem({ item, nested }: SidebarNavItemProps) {
  const closeMobile = useSidebarStore((s) => s.closeMobile);
  const pathname = useRouterState({
    select: (s) => s.location.pathname,
  });
  const isActive = isPathActive(pathname, item.href, item.exact);

  return (
    <li>
      <Link
        to={item.href}
        onClick={closeMobile}
        className={clsx(
          "flex items-center gap-2.5 rounded-md px-3 text-[13.5px]",
          "transition-colors duration-150",
          nested ? "h-8" : "h-9",
          isActive
            ? "bg-white/10 font-medium text-white"
            : "text-adara-200 hover:bg-white/5 hover:text-white",
        )}
      >
        <span
          className={clsx(
            "flex h-5 w-5 shrink-0 items-center justify-center",
            isActive ? "text-gold-400" : "text-adara-400",
          )}
        >
          {item.icon}
        </span>
        <span>{item.label}</span>
      </Link>
    </li>
  );
}
